import { useState } from "react";
import { api } from "api";

const ENDPOINT = "prod_bodega_reajustes_inventario";

export const PacasAlCorteApi = () => {
    const [cargando, setCargando] = useState(false);

    // Pacas por pallet de una fila al corte: con cierre_id, la foto de un
    // cierre cerrado; con fecha, el cierre en proceso a esa fecha y hora
    const getPacasAlCorte = async (consulta) => {
        try {
            setCargando(true);

            const response = await api.get(
                `${ENDPOINT}/pacas_al_corte`,
                consulta,
            );
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    return {
        getPacasAlCorte,

        cargando,
    };
};
